import React from 'react';
import Carousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import ConfettiExplosion from 'react-confetti-explosion';
import Button from '../Components/Button';
import { useAchievements } from '../Context/AchievementsProvider';

import { Img } from 'react-image';
import { UserAchievement } from '../Types/UserAchievement';
import './NewAchievementsModal.css';

type NewAchievementsModalProps = {
  newUserAchievements: UserAchievement[];
  onClear: () => void;
  onClose?: () => void;
};

const NewAchievementsModalView: React.FC<NewAchievementsModalProps> = ({
  newUserAchievements,
  onClear,
  onClose,
}) => {
  const handleClose = () => {
    onClear();
    onClose?.();
  };

  return (
    <div className="flex flex-col items-center justify-center w-full h-full p-4">
      <Carousel
        autoWidth
        autoHeight
        renderPrevButton={({ isDisabled }) =>
          !isDisabled && (
            <Button variant={'secondary'} onClick={() => {}}>
              Back
            </Button>
          )
        }
        renderNextButton={({ isDisabled }) =>
          !isDisabled ? (
            <Button variant={'primary'} onClick={() => {}}>
              Next
            </Button>
          ) : (
            <Button
              variant={'primary'}
              onClick={handleClose}
              testId="close-achievements-modal"
            >
              Close
            </Button>
          )
        }
      >
        {newUserAchievements?.map((userAchievement) => (
          <NewUserAchievementContratulationStep
            key={userAchievement.id}
            userAchievement={userAchievement}
          />
        ))}
      </Carousel>
    </div>
  );
};

type NewUserAchievementContratulationStepProps = {
  userAchievement: UserAchievement;
};
const NewUserAchievementContratulationStep: React.FC<
  NewUserAchievementContratulationStepProps
> = ({ userAchievement }) => {
  const { getAchievementImage } = useAchievements();

  return (
    <>
      <div className="flex flex-col gap-5 p-8 bg-white rounded-2xl border-b border-solid border-gray-200 justify-between items-center">
        <div>
          <Img
            src={getAchievementImage(userAchievement)}
            alt={userAchievement.title}
            className={`w-[80px]`}
          />
          <ConfettiExplosion zIndex={2000} particleCount={40} />
        </div>
        <div className="text-center text-black text-2xl font-bold font-['Nunito Sans']">
          Congratulations! You've Earned the {userAchievement.title} Badge!
        </div>
        <div className="text-center text-[#212529]/60 text-sm font-normal font-['Nunito Sans']">
          {userAchievement.congratulatoryMessage}
        </div>
      </div>
    </>
  );
};

export default NewAchievementsModalView;
